export const EDIT_TAGS = "/fund/update_tags/:id/";
